import type { AppThunkDispatch } from '../..';
import { makeTreeData } from '../../../components/Tree/helpers/makeTreeData';
import { MISSING_ITEMS_CATALOG } from '../../../utils/catalog/missingitems';
import { toItemNodes } from '../../../utils/tree/nodeMappers/toItemNodes';
import type { ItemDTO } from '../../mappers/dtoMappers';
import { updateData } from '../../slices/tree';
import { getMissingItems } from '../api/items';

export const fetchMissingItems =
  (tree: string) => async (dispatch: AppThunkDispatch) => {
    const { items, categories, categoriesMapped, languageCode, topCategories } =
      await dispatch(getMissingItems()).unwrap();

    const itemsObj = Object.fromEntries(
      items?.map((item) => [item.itemNo, item]) || [],
    );

    const treeData: Array<ReturnType<typeof makeTreeData> | unknown> = makeTreeData(
      {
        ...MISSING_ITEMS_CATALOG,
        globalCatalogIdentifier: 'Missing from LIVE catalogue',
        topCategories,
        isMissing: true,
      },
      categoriesMapped,
      languageCode,
      [],
      itemsObj,
    );
    const unmappedItems = getUnmappedItems(categories || [], items);

    treeData.push(...unmappedItems);

    return dispatch(
      // @ts-expect-error - updateData typing needs complex generics
      updateData(tree, treeData, {
        meta: { totalNumberOfElements: items?.length || 0 },
      }),
    );
  };

function getUnmappedItems(categories: { childItems: string[] }[], items: ItemDTO[]) {
  const childItems = categories.flatMap((m) => m.childItems);
  const unMappedItems = items.filter((f) => !childItems.includes(f.itemNo));

  const itemNodes = toItemNodes({
    catalogId: MISSING_ITEMS_CATALOG.catalogId,
    items: unMappedItems,
    level: 0,
    parentId: '0',
  });

  return itemNodes;
}
